/**
 * Een plaatje dat achter de inlog staat (de woordplaatjes, stap 29): een
 * <img> kan het token niet meesturen, dus haalt dit het plaatje als blob op
 * (via api/client.js) en toont het als object-URL. Eén keer per pad: een
 * plaatje dat al geladen is, staat in het geheugen van de pagina.
 */
import React, { useEffect, useState } from 'react';
import { verzoek } from '../api/client';

const geladen = new Map();   // pad -> object-URL (of een belofte, zolang hij laadt)

export function laadBeeld(pad) {
  if (!geladen.has(pad)) {
    const belofte = verzoek(pad, { als: 'blob' }).then((blob) => {
      const url = URL.createObjectURL(blob);
      geladen.set(pad, url);
      return url;
    }).catch((err) => { geladen.delete(pad); throw err; });
    geladen.set(pad, belofte);
  }
  const waarde = geladen.get(pad);
  return typeof waarde === 'string' ? Promise.resolve(waarde) : waarde;
}

export function Beeld({ pad, alt, grootte = 160, style, ...rest }) {
  const [url, setUrl] = useState(() => (typeof geladen.get(pad) === 'string' ? geladen.get(pad) : null));
  const [mislukt, setMislukt] = useState(false);

  useEffect(() => {
    let weg = false;
    setMislukt(false);
    if (!pad) return undefined;
    laadBeeld(pad).then(u => { if (!weg) setUrl(u); }).catch(() => { if (!weg) setMislukt(true); });
    return () => { weg = true; };
  }, [pad]);

  const maat = { width: grootte, height: grootte, objectFit: 'contain', borderRadius: 8, background: 'var(--wit)', ...style };
  if (mislukt) return <div style={{ ...maat, display: 'grid', placeItems: 'center', fontSize: 12 }} className="text-muted">geen plaatje</div>;
  if (!url) return <div style={{ ...maat, background: 'var(--vlak)' }} aria-busy="true" />;
  return <img src={url} alt={alt} style={maat} {...rest} />;
}
